var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.fieldKey,"value":_vm.value},on:{"input":_vm.handleOnInput}})}
var staticRenderFns = []

export { render, staticRenderFns }